import React from "react";
import style from "./styles.module.scss";
import SkeletonLoader from "../../../../components/skeleton-loader";

function PricingDefaultsLoader() {
  return (
    <div className={style.skeletonAccordion}>
      {Array.from({ length: 8 }).map((_, index) => (
        <div
          key={`skeleton-accordion-item-${index}`}
          className={style.skeletonAccordionItem}
        >
          <div>
            <div>
              <SkeletonLoader
                variant="rectangular"
                width="12px"
                height="13px"
              />
              <SkeletonLoader variant="text" width="95px" height="19px" />
            </div>
            <SkeletonLoader variant="text" width="41px" height="20px" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default PricingDefaultsLoader;
